import gql from 'graphql-tag';

export const GET_BRAND = gql`
    query Brand($brandId: String!) {
        brand(id: $brandId) {
            id
            accountSlug
            slug
            brandLogoUrl
            name
            localizations {
                id
                name
                cultureCode
                cultureName
                targetUrl
            }
            sizeFormats {
                id
                width
                height
                name
            }
        }
    }
`;

export const GET_BRAND_PALETTE = gql`
    query BrandPalettes($id: String!) {
        brand(id: $id) {
            palettes {
                name
                swatch
            }
        }
    }
`;
